export default function translateDocumetnUpdateTaskFailedReason(reason: string): string {
  switch (reason) {
    case 'DOCUMENT_NOT_ACCESSIBLE':
      return '계약 접근 권한이 없습니다.';
    case 'DOCUMENT_NOT_FOUND':
      return '존재하지 않는 계약입니다.';
    case 'PENDING_DOCUMENT_EXIST':
      return '계약이 이미 업데이트 대기중입니다.';
    case 'UNPROCESSABLE':
      return '처리할 수 없습니다.';
    default:
      return reason;
  }
}
